import { __assign } from "tslib";
import React from 'react';
import { DataLoaderContextComponent } from './data-loader-context';
import { DataLoaderStoreAndLoader } from './data-loader-store-and-loader';
export var DataProvider = function (props) {
    var dataLoader = React.useState(function () {
        return new DataLoaderStoreAndLoader(props.onEvent || (function () { }), props.initialState, function (params) {
            var dataLoader = props.resources.getResourceLoader(params.resourceType);
            if (!dataLoader) {
                return Promise.reject("No data loader present for " + params.resourceType);
            }
            return dataLoader.loadResource(__assign(__assign({}, props.globalProps), params));
        }, function (resourceType, dataLoadParams) {
            return props.resources.generateCacheKey(resourceType, dataLoadParams);
        }, props.isServerSideRender || false);
    })[0];
    return (React.createElement(DataLoaderContextComponent.Provider, { value: dataLoader }, props.children));
};
DataProvider.displayName = 'DataLoaderProvider';
//# sourceMappingURL=data-provider.js.map